export default "__VITE_ASSET__bW0gxAmN__"